import { storeToRefs } from 'pinia';
import type { Ref } from 'vue';
import { computed } from 'vue';
import type { IMatch } from '@/interface/IMatch';
import { useCountdownTimer } from '@/libraries/composables/useCountdownTimer';
import { useFeatureToggleStore } from '@/stores/featureToggleStore';

export function useEventCountdown(event: Ref<IMatch>) {
    const realKickoffTime = computed(() => event.value.realKickoffTime);
    const {
        formattedTime: countdownDisplay,
        timeDifference,
    } = useCountdownTimer(realKickoffTime);

    const isShowCountdownHours = computed(() => countdownDisplay.value.hours !== '00');

    const { ePenaltyLeagueIds } = storeToRefs(useFeatureToggleStore());
    const isShowCountdown = computed(() => {
        const remainingSeconds = timeDifference.value.totalSeconds;
        return ePenaltyLeagueIds.value.includes(event.value.leagueId) && remainingSeconds > 0;
    });

    return {
        countdownDisplay,
        isShowCountdownHours,
        isShowCountdown,
    };
}
